import React, { useContext } from 'react';
import WarehouseTable from './WarehouseTable';
import { CommonContext, WarehouseMasterContext } from '../../context';
import { Box, Button, CardHeader, Paper, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import AddModal from './AddModal';
import FilterBar from './FilterBar';
import { useNavigate } from 'react-router-dom';

export default function WarehouseMasterScreenview() {
  const { openAlert } = useContext(CommonContext);
  const { isLoading, handleAddModal, locationState, onExport } = useContext(WarehouseMasterContext);
  const navigate = useNavigate();

  return (
    <div className='main-screen'>
      {openAlert && <AlertMessage />}
      {isLoading && <Loader />}
      <AddModal />

      {locationState && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }}>
          <Button
            variant="outlined"
            className="action-btn"
            onClick={() => navigate('/merchants/registered')}
            startIcon={<ArrowBack />}
          >
            Back
          </Button>
        </Box>
      )}

      <Box className="component-header">
        <CardHeader
          title={
            <span>
              Warehouse Master {locationState && <span style={{ fontSize: '18px', color: '#333', fontWeight: 600 }}>- {locationState.company_name}</span>}
            </span>
          }
        />
        <Box className="action-btns-group">
          {/* <Button variant="outlined" className="action-btn" onClick={onExport}>
            Export Warehouse[s]
          </Button> */}
          <Button variant="outlined" className="action-btn" onClick={handleAddModal}>
            Add Warehouse
          </Button>
        </Box>
      </Box>
      <Paper sx={{ boxShadow: 'none' }}>
        <FilterBar />
        <WarehouseTable />
      </Paper>
    </div>
  );
}